import type { PropsWithClassName } from "@models/types/index";
import { CloseIcon } from "../Icons/index";

export function CloseButton({
  onClose,
  className,
}: { onClose: () => void } & PropsWithClassName) {
  return (
    <button
      onClick={onClose}
      className={`h-10 w-10 flex lg:hidden items-center justify-center ${className}`}
      type="button"
    >
      <CloseIcon width="15" height="15" />
    </button>
  );
}
